import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"

export default function JolliPlayCampaign() {
  const data = promotionsData.find(
    (promo) => promo.title === "Jolliplay Exclusive Campaign"
  )
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>JolliPlay Exclusive Campaign</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion">Promotions</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> Jolliplay Exclusive Campaign </h1>{" "}
                  <h2>Event 1 - Bet Challenge - Free Spins</h2>
                  <div className="promotion-tnc-period">
                    <p>
                      <strong> Promo Period: </strong>
                      <span>
                        Sept 01, 2025 00:00:00 - Sept 30, 2025 (11:59AM){" "}
                      </span>
                    </p>
                  </div>
                  <div className="promotion-tnc-mechanic-content">
                    <strong> Terms & Conditions </strong>{" "}
                    <ol>
                      <li>
                        The{" "}
                        <strong className="highlight">
                          JolliPlay September Exclusive Campaign
                        </strong>{" "}
                        is conditioned-based and available to eligible players
                        who participate first and meet the specific{" "}
                        <strong className="highlight">
                          turnover condition
                        </strong>{" "}
                        within the campaign period.
                      </li>
                      <li>
                        The campaign will run from{" "}
                        <strong className="highlight">
                          Sept 01, 2025 00:00:00 to Sept 30, 2025 23:59:59
                          (GMT+8),
                        </strong>{" "}
                        and the reward distribution will be carried out in{" "}
                        <strong className="highlight">three batches</strong> as
                        follows
                        <ol>
                          <br />
                          <li>
                            <strong className="highlight">Batch 1:</strong> Sept
                            01, 2025 00:00:00 – Sept 30, 2025 23:59:59 (GMT+8)
                          </li>
                          <li>
                            <strong className="highlight">Batch 2:</strong> Sept
                            11, 2025 00:00:00 – Sept 30, 2025 23:59:59 (GMT+8)
                          </li>
                          <li>
                            <strong className="highlight">Batch 3:</strong> Sept
                            21, 2025 00:00:00 – Sept 30, 2025 23:59:59 (GMT+8)
                          </li>
                        </ol>
                      </li>
                      <li>
                        During the campaign period, Free Spins will be offered
                        in{" "}
                        <strong className="highlight">
                          three separate batches.
                        </strong>{" "}
                        The value of Free Spins and specific activity criteria
                        for each batch will be made available within the{" "}
                        <strong className="highlight">
                          {" "}
                          in-game Free Spins Wallet during the respective batch
                          periods
                        </strong>
                        .
                      </li>
                      <li>
                        Free Spins will be{" "}
                        <strong className="highlight">
                          distributed automatically
                        </strong>{" "}
                        by AdvantPlay to players who meet the participation
                        criteria during the campaign period.
                      </li>
                      <li>
                        When players fulfill the turnover conditions, free Spins
                        will be credited to{" "}
                        <strong className="highlight">
                          JolliPlay Free Spins Wallet
                        </strong>
                        .
                      </li>
                    </ol>
                    <strong>Qualified Games</strong>
                    <MasterGamesList
                      advantGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customAdvantGames={[
                        {
                          provider: "jolliplay",
                          gameName: "Buffalo Rush HIGHROLLER",
                        },
                        { provider: "jolliplay", gameName: "Golden Egypt" },
                        { provider: "jolliplay", gameName: "Mahjong Roar" },
                        {
                          provider: "jolliplay",
                          gameName: "LABUBU: Fall In Wild",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Maya: Elemental Totem 2",
                        },
                        { provider: "jolliplay", gameName: "Big Net Bass" },
                        {
                          provider: "jolliplay",
                          gameName: "Disco 777 Hold and Win",
                        },
                        { provider: "jolliplay", gameName: "Sugar Crush" },
                        { provider: "jolliplay", gameName: "Piggy Bank Gold" },
                        {
                          provider: "jolliplay",
                          gameName: "Squid Game 2：Mukunghwa",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Leprechaun’s Fortune",
                        },
                        { provider: "jolliplay", gameName: "BlackJack 21" },
                        {
                          provider: "jolliplay",
                          gameName: "Pirate Treasure Hunt",
                        },
                        { provider: "jolliplay", gameName: "Cai Shen Fortune" },
                        {
                          provider: "jolliplay",
                          gameName: "Aztec: Gold Temple",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Crazy Bounty: Jackpot",
                        },
                        { provider: "jolliplay", gameName: "Rush Hour Gold" },
                        { provider: "jolliplay", gameName: "Buffalo Rush" },
                        {
                          provider: "jolliplay",
                          gameName: "Rhapsody of Muertos",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Phantom Multiplier",
                        },
                        { provider: "jolliplay", gameName: "Starry Adventure" },
                        {
                          provider: "jolliplay",
                          gameName: "Fish Prawn Crab Bonanza",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Aztec: Bonus Hunt 2",
                        },
                        { provider: "jolliplay", gameName: "Football Fever" },
                        { provider: "jolliplay", gameName: "Firefly Hunter" },
                        { provider: "jolliplay", gameName: "Dark Ritual" },
                        { provider: "jolliplay", gameName: "Hungry Slime" },
                        {
                          provider: "jolliplay",
                          gameName: "Maya: Elemental Totem",
                        },
                        {
                          provider: "jolliplay",
                          gameName: "Dragon Chi’s Quest",
                        },
                        { provider: "jolliplay", gameName: "Last Samurai" },
                      ]}
                      rank="off"
                      limit={50}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                    <div>
                      <ol start={6}>
                        <li>
                          Players may start betting upon entering games via Free
                          Spins Wallet.
                        </li>
                        <li>
                          Winnings from the free spins are required to complete
                          the Turnover Requirement (3x) in the Bonus Wallet.
                        </li>
                        <li>
                          Players must complete the Turnover Requirement (3x) in
                          the Bonus Wallet. After meeting the turnover
                          requirements, the eligible withdrawal balance will be
                          automatically transferred to the Cash Wallet so that
                          withdrawals can be performed anytime (subject to a
                          maximum amount cap).
                        </li>
                        <li>
                          Only wagers made via Bonus Wallet will contribute
                          towards the turnover requirement. Wagers made via Cash
                          Wallet will not count towards the turnover
                          requirement.
                        </li>
                        <li>
                          The promotion will end when the balance of the bonus
                          wallet drops below the minimum stake level.
                        </li>
                        <li>
                          In the event of invalid tickets caused by AdvantPlay,
                          refunds will be issued to the player’s Bonus Wallet,
                          and the affected ticket’s turnover/win-loss will be
                          considered null (counted as 0).
                        </li>
                        <li>
                          Any balance exceeding the maximum withdrawal amount
                          will be cleared upon completion of the turnover
                          requirement.
                        </li>
                        <li>
                          Players are allowed to use only{" "}
                          <strong className="highlight">ONE</strong> valid
                          registered account with the platform. Any attempt to
                          manipulate or abuse the campaign, including creating
                          multiple accounts or using automated systems, may
                          result in disqualification and forfeiture of winnings.
                        </li>
                        <li>
                          AdvantPlay reserves the right to modify the terms and
                          conditions of this campaign at any time.
                        </li>
                        <li>
                          All decisions made by AdvantPlay regarding this
                          campaign are final.
                        </li>
                      </ol>
                    </div>
                    <div className="promotion-tnc-cta">
                      <a
                        href="/slots/?provider=JOLLIPLAY"
                        className="promotion-cta-btn"
                      >
                        Play Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
